import DateFnsUtils from '@date-io/date-fns';

import format from 'date-fns/format';
import koLocale from 'date-fns/locale/ko';

import dayjs from 'dayjs';
import 'dayjs/locale/ko';
dayjs.locale('ko');

class KoLocalizedUtils extends DateFnsUtils {
  getCalendarHeaderText(date: number | Date) {
    return format(date, 'yyyy년 MMMM', { locale: koLocale });
  }

  getDatePickerHeaderText(date: number | Date) {
    return format(date, 'MMMM dd일', { locale: koLocale });
  }
}

export default KoLocalizedUtils;

export function getDayOfWeek(date: string) {
  return dayjs(date).format('ddd');
}
